import { assertEnv } from "@homeinstead/shared";
import { redirect } from "next/navigation";

export const FRANCHISE_ROOT_DEV = "/franchise-opportunities";

export const isDevOrPreview = () => {
  const deployEnv = assertEnv(
    "NEXT_PUBLIC_DEPLOY_ENV",
    process.env.NEXT_PUBLIC_DEPLOY_ENV,
  );

  const isDev = deployEnv === "development";
  const isPreview = deployEnv === "preview";

  return isDev || isPreview;
};

// This is only set on staging and nowhere else
// and it should only change the logic in the routing.
// We need other deployEnv related logic to remain the same for Franchises it's just
// the URLs we're changing with the new staging.franchises.homeinstead.com URL.
export const isStagingFranchises = () => {
  return process.env.NEXT_PUBLIC_FRANCHISE_ENV === "staging";
};

export const getFranchiseOpportunitiesRoute = (path: string = "") => {
  return isDevOrPreview() && !isStagingFranchises()
    ? `/franchise-opportunities${path}`
    : path;
};

export const handleDrawerClose = ({
  searchParams,
  pathname,
}: {
  searchParams: URLSearchParams;
  pathname: string;
}) => {
  const params = new URLSearchParams(searchParams.toString());
  params.delete("leadVariant");

  const queryString = params.toString();
  const newPath = queryString ? `${pathname}?${queryString}` : pathname;

  redirect(newPath);
};
